import { render, staticRenderFns } from "./SelfTest.vue?vue&type=template&id=63c4703a&scoped=true"
import script from "./SelfTest.vue?vue&type=script&lang=js"
export * from "./SelfTest.vue?vue&type=script&lang=js"
import style0 from "./SelfTest.vue?vue&type=style&index=0&id=63c4703a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4703a",
  null
  
)

export default component.exports